
const LocationsSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Serving Multiple Locations
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-8">
            <p>
              HP Inc Consulting Services operates across the Northeast region, including New York, New Jersey, Pennsylvania, Connecticut, Maryland, and Boston. No matter where your company is located, we deliver consistent, high-quality safety training tailored to your needs.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {[
              'New York', 'New Jersey', 'Pennsylvania', 'Connecticut', 'Maryland',
              'Boston'
            ].map((city) => (
              <div key={city} className="bg-white p-4 rounded-lg shadow-md text-center">
                <i className="ri-map-pin-fill text-blue-600 text-2xl mb-2"></i>
                <p className="font-semibold text-gray-900">{city}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
